export default "__VITE_ASSET__C5b_98YX__";